import { compose } from 'redux';
import { connect } from 'react-redux';
import withFormValidation from 'app/HOC/withFormValidation';
import LayoutModule from 'app/store/layout';
import cinemaRentModule from 'app/store/cinemaRent';
import CinemaRentInquiry from './CinemaRentInquiry.component';
import { schema } from './CinemaRentInquiry.schema';

const { createToast, setLoader } = LayoutModule.actions;

const { sendCinemaRentInquiryRequest } = cinemaRentModule.actions;

const mapStateToProps = ({ layout, cinemas, cinemaRent, information: { legalInfoContent } }) => ({
  locations: layout.locations,
  cinemas: cinemas.cinemas,
  legalInfo: legalInfoContent.slice(),
  cinemaRentInquiryResult: cinemaRent.cinemaRentInquiry
});

const mapDispatchToProps = {
  notify: createToast,
  sendCinemaRentInquiry: sendCinemaRentInquiryRequest,
  setLoader
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFormValidation(schema)
)(CinemaRentInquiry);
